import { render, staticRenderFns } from "./SaleDetail.vue?vue&type=template&id=45959f15&scoped=true"
import script from "./SaleDetail.vue?vue&type=script&lang=ts"
export * from "./SaleDetail.vue?vue&type=script&lang=ts"
import style0 from "./SaleDetail.vue?vue&type=style&index=0&id=45959f15&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45959f15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45959f15')) {
      api.createRecord('45959f15', component.options)
    } else {
      api.reload('45959f15', component.options)
    }
    module.hot.accept("./SaleDetail.vue?vue&type=template&id=45959f15&scoped=true", function () {
      api.rerender('45959f15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/SaleDetail.vue"
export default component.exports